module.exports = __webpack_public_path__ + "img/cloud.0c3164d2.png";